'use client';

import { createContext, type ReactNode, useContext } from 'react';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

import { myCollectionConfig } from './config';
import type { MyCollectionPageConfig } from './types';

const MyCollectionPageConfigContext = createContext<MyCollectionPageConfig | null>(null);

interface Props {
  children: ReactNode;
}

export function MyCollectionPageConfigProvider({ children }: Props) {
  const { teamSlug } = useTeamConfig();
  const config = myCollectionConfig[teamSlug];

  return <MyCollectionPageConfigContext.Provider value={config}>{children}</MyCollectionPageConfigContext.Provider>;
}

export function useMyCollectionPageConfig() {
  const context = useContext(MyCollectionPageConfigContext);

  if (!context) {
    throw new Error('useMyCollectionPageConfig must be used within MyCollectionPageConfigProvider');
  }

  return context;
}
